import { createSelector } from 'reselect';
import { JobsState, RootState } from '../state';
import { JobPhase, LIVE_MAP_PHASES } from '../../shared/models/jobs';
import { isTodayFutureTime, isTodayOrBefore } from '../../shared/utils/date-utils';

export const selectJobsState = (state: RootState) => state?.jobs?.jobs;

export const selectJobs = createSelector(
  selectJobsState,
  (state: JobsState) => state?.data
);

export const selectActiveJobs = createSelector(
  selectJobsState,
  (state: JobsState) => state?.data?.filter((job) => {
    return job.phase && ![JobPhase.Feedback, JobPhase.Cancelled, JobPhase.Completed].includes(job.phase) && isTodayOrBefore(job.due_time);
  }).sort((a,b) => a.due_time - b.due_time)
);

export const selectNotActiveJobs = createSelector(
  selectJobsState,
  (state: JobsState) => state?.data?.filter((job) => {
    return [JobPhase.Feedback, JobPhase.Cancelled, JobPhase.Completed].includes(job.phase) && isTodayFutureTime(job.completed_time);
  }).sort((a,b) => a.due_time - b.due_time)
);

export const selectLiveMapActiveJobs = createSelector(
  selectJobsState,
  (state: JobsState) => state?.data?.filter((job) => {
    return job.phase && LIVE_MAP_PHASES.includes(job.phase) && isTodayOrBefore(job.created_time);
  })
);